module.exports = __webpack_public_path__ + "img/clock-white.94f7df41.svg";